// src/components/common/BetButton.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useBetSlip } from '../../context/BetSlipContext';

const BetButton = ({ 
  odds, 
  selection, 
  match, 
  matchId, 
  sport, 
  type = 'home',
  isCompact = false 
}) => {
  const [isAdded, setIsAdded] = useState(false);
  const { addToBetSlip, bets } = useBetSlip();
  const navigate = useNavigate();

  const handleAddToBetSlip = () => {
    const bet = {
      matchId,
      match: match,
      selection,
      odds: parseFloat(odds),
      sport,
      type
    };
    
    const success = addToBetSlip(bet);
    if (success) {
      setIsAdded(true);
      
      // Show success message
      setTimeout(() => {
        setIsAdded(false);
      }, 2000);
    }
  };

  const handleQuickBet = () => {
    handleAddToBetSlip();
    navigate('/betslip');
  };

  // Check if this bet is already in betslip
  React.useEffect(() => {
    const exists = bets.some(b => 
      b.matchId === matchId && b.selection === selection
    );
    setIsAdded(exists);
  }, [bets, matchId, selection]);

  const getButtonClass = () => {
    const baseClass = "flex-1 py-2 sm:py-3 text-center transition-all duration-200 rounded-lg ";
    
    if (isAdded) {
      return baseClass + "bg-green-600 text-white cursor-default";
    }
    
    switch(type) {
      case 'home':
        return baseClass + "bg-gray-800 hover:bg-blue-600 text-white";
      case 'draw':
        return baseClass + "bg-gray-800 hover:bg-gray-700 text-white";
      case 'away':
        return baseClass + "bg-gray-800 hover:bg-red-600 text-white";
      default:
        return baseClass + "bg-gray-800 hover:bg-gray-700 text-white";
    }
  };

  return (
    <div className="relative group">
      <button
        onClick={handleAddToBetSlip}
        className={getButtonClass()}
        disabled={isAdded}
      >
        <div className={`${isCompact ? 'text-xs' : 'text-sm'} text-gray-300 mb-1`}>
          {selection}
        </div>
        <div className={`${isCompact ? 'text-base' : 'text-lg'} font-bold`}>
          {odds}
        </div>
        {isAdded && (
          <div className={`${isCompact ? 'text-xs' : 'text-sm'} mt-1 text-green-300`}>
            ✓ Added
          </div>
        )}
      </button>
      
      {!isAdded && !isCompact && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hidden sm:block">
          <div className="bg-gray-900 text-white text-xs rounded px-2 py-1 whitespace-nowrap">
            Add to betslip
          </div>
        </div>
      )}
    </div>
  );
};

export default BetButton;